import "../../style/scss/App.scss";

export default function EducationListItem({ education, onEdit }) {
  const edu = education || {};
  const id = edu.ID || edu.id;
  const years =
    edu.YearStart || edu.YearEnd
      ? `${edu.YearStart || "?"} – ${edu.YearEnd || "Present"}`
      : "";

  return (
    <button
      type="button"
      className="centered skillLink location-list-item"
      data-testid={`education-list-item-${id}`}
      onClick={() => onEdit?.(id)}
    >
      <div className="Job mobilePanel">
        <span className="title">{edu.Degree || "Education"}</span>
        <span className="byline">{edu.InstitutionName || edu.institutionName || ""}</span>
        <span className="rightText">{years}</span>
      </div>
    </button>
  );
}
